export function CommaDecode(str) {
  var index = str.indexOf("&");
  if (index == -1) return str;

  var done = false;
  while (!done) {
    var n = str.length;
    str = str.replace("&com;", ",");
    var n1 = str.length;
    if (n == n1) done = true;
  }

  return str;
}
